import { League, FantasyTeam } from '../../models';
import _ from 'lodash';
import User from '../../../../core/models/User';

export class FixtureModel extends League {
	get defaults() {
		return {
			...super.defaults,
			'team_proj_score': '-'
		}
	}
	/**
	 * Set fixture data for current league
	 * @returns {LeagueModel}
	 */
	setFixtureList() {
		if (this.get('type')==='head_to_head') {
			let fixture = this.get('fixture'),
				fixture_list = {};

			if (!_.isEmpty(fixture)) {
				_.each(fixture, (item, round) => {
					fixture_list[round] = this.getFixtureItem(item, {}, parseInt(round, 10));
				});

				this.set('fixtures', fixture_list);
			}
		}

		return this;
	}

	/**
	 * Set fixture item by round_id and fixture_pair
	 * @param round_id
	 * @param fixture_pair
	 * @returns {LeagueModel}
	 */
	setFixtureItem({ round_id = 1, home_team_id, away_team_id }) {
		const fixture_item = this.getFixturePairs({
			fixture: this.get('fixture')[round_id],
			home_team_id, away_team_id,
			round_id,
		});

		this.set({ fixture_item });

		return this;
	}

	getFixturePairs({ fixture, home_team_id, away_team_id }) {
		let fixture_items = {};

		_.each(fixture, (item, key) => {

			let first_opponent = this.getFixtureTeam(item[0]),
				second_opponent = this.getFixtureTeam(item[1]),
				is_selected = false,
				ids = [home_team_id, away_team_id]
			;

			if (!_.isEmpty(first_opponent) && !_.isEmpty(second_opponent)) {
				is_selected = ids.includes(first_opponent.id);
			}

			fixture_items[key] = {
				first_opponent,
				second_opponent,
				is_selected
			}
		});

		return fixture_items;
	}

	/**
	 * Get Fixture by league id
	 * @param round_id
	 * @param team_id
	 * @returns {*}
	 */
	getFixtureById({ round_id = 1, team_id }) {
		const round_fixtures = this.get('fixture')[round_id];

		return _.values(round_fixtures).find(arr => arr.includes(team_id));
	}

	/**
	 * Get fixture item use fixtures object
	 * @param fixture
	 * @param fixture_pair
	 * @param current_round
	 * @returns {{}}
	 */
	getFixtureItem(fixture, fixture_pair, current_round = 1) {
		let { rounds } = this.attributes;
		if (_.isEmpty( rounds )) {
			rounds = this.attributes.rounds_collection.toJSON();
		}

		const round = rounds.find(round => {
			return round.id === current_round
		});

		// TODO: Remove changes from NF21BAU-113 during off-season work.
		const isQERound = round && round.final_prefix === 'Qualifying/Elimination Final';

		let fixture_items = {};
		if (_.isEmpty(fixture)) {
			return fixture_items;
		}

		let sorted_fixtures = fixture;

		if (isQERound) {
			const [first, third, fourth, second] = fixture;
			sorted_fixtures = [first, second, third, fourth];
		}

		_.each(sorted_fixtures, (item, key) => {
			let first_opponent = item[0] ? new FantasyTeam(this.getFixtureTeam(item[0])) : {},
				second_opponent = item[1] ? new FantasyTeam(this.getFixtureTeam(item[1])) : {}
			;

			first_opponent = this.getScore( first_opponent, current_round );
			second_opponent = this.getScore( second_opponent, current_round );

			fixture_items[key] = {
				first_opponent: !_.isEmpty(first_opponent) ? first_opponent.toJSON() : {},
				second_opponent: !_.isEmpty(second_opponent) ? second_opponent.toJSON() : {},
				is_selected: this.isSelectTeam(first_opponent, second_opponent, fixture_pair)
			};
		});

		return fixture_items;
	}

	isSelectTeam(first_opponent, second_opponent, fixture_pair) {
		let is_selected = false;

		if (!_.isEmpty(first_opponent) && !_.isEmpty(second_opponent) && fixture_pair) {
			is_selected = first_opponent.id === fixture_pair.home_team_id
				|| first_opponent.id === fixture_pair.away_team_id;
		}

		return is_selected;
	}

	getScore(team, current_round) {
		team = this.setTeamProjScore( team, current_round );

		return team;
	}

	/**
	 * Get fixture team bye team_id
	 * @param team_id
	 * @returns team or {{}}
	 */
	getFixtureTeam( team_id ) {
		let teams = this.get('teams'),
			team = teams.filter(function(team) {
				return team.id === team_id;
			});

		return (!_.isEmpty(team[0])) ? team[0] : {};
	}

	setMyTeamsProjScores() {
		if(!User.has_assistant_coach)
			return this;

		let home = this.get('home'),
			away = this.get('away'),
			current_round = this.get('current_round');

		if(home) {
			home = this.setTeamProjScore(new FantasyTeam(home), current_round);
			this.set('home', home.toJSON());
		}

		if(away) {
			away = this.setTeamProjScore(new FantasyTeam(away), current_round);
			this.set('away', away.toJSON());
		}

		return this;
	}
}

export default FixtureModel;